<div class="project-sidebar-details" *ngIf="project">
		<h3>{{ 'DETAILS' | translate }}</h3>

		<div class="line">
			<label>ID</label>
			<code>{{project.id}}</code>
		</div>
		<div class="line">
			<label>{{ 'CREATED' | translate }}</label>
			<div>
				<p class="text-only" [title]="project.createddate | bbDate">
					{{ project.createddate | bbDate:'relative' }}
				</p>
				<small *ngIf="project?.createdBy"> {{ 'BY' | translate }}
					<a *ngIf="createdByIsEmailAddress" class="blue" [href]="'mailto:' + project?.createdBy">{{ project?.createdBy }}</a>
					<span class="black" *ngIf="!createdByIsEmailAddress">{{ project?.createdBy }}</span>
				</small>
			</div>
		</div>
		<div class="line">
			<label>{{ 'MODIFIED' | translate }}</label>
			<div>
				<p [title]="project.updateddate | bbDate">
						{{ project.updateddate | bbDate:'relative' }}
				</p>
				<small *ngIf="project?.updatedBy"> {{ 'BY' | translate }}
					<a *ngIf="updatedByIsEmailAddress" class="blue" [href]="'mailto:' + project?.updatedBy">{{ project?.updatedBy }}</a>
					<span class="black" *ngIf="!updatedByIsEmailAddress">{{ project?.updatedBy }}</span>
				</small>
			</div>
		</div>
		<div class="line">
			<label>{{ 'PUBLISHED' | translate }}</label>
			<div>
				<p *ngIf="project.publisheddate" [title]="project.publisheddate | bbDate" >
						{{ project.publisheddate | bbDate:'relative' }}
				</p>
				<p class="gray" *ngIf="!project.publisheddate">{{'NOT_YET_PUBLISHED' | translate}}</p>
			</div>
		</div>
		<div class="line">
			<label>{{ 'START_CLIP' | translate }}</label>
			<div class="input">
				<a class="blue" *ngIf="mainMediaClip" [routerLink]="['/library/mediaclip/', mainMediaClip.id, 'metadata']">
					<span [innerHTML]="mainMediaClip | clipTitle"></span>
				</a>
				<span class="gray" *ngIf="!project.mainMediaClipId">{{'NO_STARTCLIP_SELECTED' | translate}}</span>
			</div>
		</div>

	</div>
